export default {
    /* eslint-disable */

    install (Vue, options) {
        // 判断是否是数组
        Vue.prototype.$text = {
            DB_SUPERVISO_COURSE: [
                {
                    label: "开课院系",
                    disabled: true,
                    checked: true,
                    prop: "courseOrgName"
                },
                {
                    label: "课程名称",
                    disabled: true,
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "平均分",
                    disabled: true,
                    checked: true,
                    prop: "averageScore"
                },
                {
                    label: "排名",
                    checked: true,
                    prop: "orderNum"
                }
            ],
            //学生评教(课程得分对比)
            DB_STUDENT_COURSE: [
                {
                    label: "开课院系",
                    disabled: true,
                    checked: true,
                    prop: "courseOrgName"
                },
                {
                    label: "课程编码",
                    disabled: true,
                    checked: true,
                    prop: "courseCode"
                },
                {
                    label: "课程名称",
                    disabled: true,
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "实际平均分",
                    disabled: true,
                    checked: true,
                    prop: "averageScore"
                },
                {
                    label: "有效平均分",
                    disabled: true,
                    checked: true,
                    prop: "actualAverageScore"
                },
                {
                    label: "排名",
                    checked: true,
                    prop: "orderNum"
                }
            ],
            // 督导、领导、同行 课程得分对比
            DB_COLLEAGUE_COURSE: [
                {
                    label: "开课院系",
                    disabled: true,
                    checked: true,
                    prop: "courseOrgName"
                },
                {
                    label: "课程名称",
                    disabled: true,
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "平均分",
                    disabled: true,
                    checked: true,
                    prop: "averageScore"
                },
                {
                    label: "排名",
                    checked: true,
                    prop: "orderNum"
                }
            ],
            // 同行--教师得分对比
            DB_COLLEAGUE_TEACHER: [
                {
                    label: "教师所在部门",
                    disabled: true,
                    checked: true,
                    prop: "orgName"
                },
                {
                    label: "教师",
                    disabled: true,
                    checked: true,
                    prop: "teacherName"
                },
                {
                    label: "教工号",
                    disabled: true,
                    checked: true,
                    prop: "teacherCode"
                },
                {
                    label: "性别",
                    checked: false,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    checked: false,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类别",
                    checked: false,
                    prop: "teacherType"
                },
                {
                    label: "平均分",
                    disabled: true,
                    checked: true,
                    prop: "averageScore"
                },
                {
                    label: "排名",
                    checked: true,
                    prop: "orderNum"
                }
            ],
            // 学生--学生评教(教师得分对比)
            DB_STUDENT_TEACHER: [
                {
                    label: "开课院系",
                    index: 5,
                    checked: true,
                    prop: "college"
                },
                {
                    label: "课程名称",
                    index: 6,
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "课程类型",
                    index: 7,
                    checked: true,
                    prop: "courseTypeName"
                },
                {
                    label: "选课课号",
                    index: 8,
                    checked: true,
                    prop: "courseNum"
                },
                {
                    label: "教师所在部门",
                    index: 1,
                    checked: true,
                    disabled: true,
                    prop: "orgName"
                },
                {
                    label: "教工号",
                    disabled: true,
                    checked: true,
                    index: 2,
                    prop: "teacherCode"
                },
                {
                    label: "教师姓名",
                    index: 3,
                    disabled: true,
                    checked: true,
                    prop: "teacherName"
                },
                {
                    label: "性别",
                    index: 9,
                    checked: false,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    index: 10,
                    checked: false,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类型",
                    index: 11,
                    checked: false,
                    prop: "teacherType"
                },
                {
                    label: "授课班级",
                    index: 4,
                    checked: true,
                    prop: "classs"
                },
                {
                    label: "评价次数",
                    index: 12,
                    checked: true,

                    prop: "evaluateCount"
                },
                {
                    label: "实际参评率",
                    index: 13,
                    checked: true,
                    srot: true,
                    prop: "evalPercent"
                },
                {
                    label: "有效参评率",
                    index: 14,
                    checked: true,
                    srot: true,
                    prop: "actualEvalPercent"
                },
                {
                    label: "实际得分",
                    index: 15,
                    checked: true,
                    srot: true,
                    prop: "averageScore"
                },
                {
                    label: "有效得分",
                    index: 16,
                    checked: true,
                    srot: true,
                    prop: "actualAverageScore"
                },
                {
                    label: "主观评价",
                    index: 17,
                    checked: true,
                    prop: "subjectives"
                }
            ],
            // 学生--学生评教(教师报告)
            DB_STUDENT_TEACHER_REPORT: [
                {
                    label: "教师所在部门",
                    index: 1,
                    checked: true,
                    disabled: true,
                    prop: "orgName"
                },
                {
                    label: "教工号",
                    disabled: true,
                    checked: true,
                    index: 2,
                    prop: "teacherCode"
                },
                {
                    label: "教师姓名",
                    index: 3,
                    disabled: true,
                    checked: true,
                    prop: "teacherName"
                },
                {
                    label: "性别",
                    index: 9,
                    checked: false,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    index: 10,
                    checked: false,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类型",
                    index: 11,
                    checked: false,
                    prop: "teacherType"
                },
                {
                    label: "授课班级",
                    index: 4,
                    checked: true,
                    prop: "classs"
                },
                {
                    label: "开课院系",
                    index: 5,
                    checked: true,
                    prop: "college"
                },
                {
                    label: "课程名称",
                    index: 6,
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "课程类型",
                    index: 7,
                    checked: true,
                    prop: "courseTypeName"
                },
                {
                    label: "选课课号",
                    index: 8,
                    checked: true,
                    prop: "courseNum"
                },
                {
                    label: "评价次数",
                    index: 12,
                    checked: true,

                    prop: "evaluateCount"
                },
                {
                    label: "实际参评率",
                    index: 13,
                    checked: true,
                    srot: true,
                    prop: "evalPercent"
                },
                {
                    label: "有效参评率",
                    index: 14,
                    checked: true,
                    srot: true,
                    prop: "actualEvalPercent"
                },
                {
                    label: "实际得分",
                    index: 15,
                    checked: true,
                    srot: true,
                    prop: "averageScore"
                },
                {
                    label: "有效得分",
                    index: 16,
                    checked: true,
                    srot: true,
                    prop: "actualAverageScore"
                },
                {
                    label: "评价报告",
                    index: 17,
                    checked: true,
                    prop: "subjectives"
                }
            ],
            DB_STUDENT_TEACHER_C: [
                {
                    label: "开课院系",
                    disabled: true,
                    checked: true,
                    prop: "courseOrgName"
                },
                {
                    label: "课程名称",
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "任课教师",
                    checked: true,
                    disabled: true,
                    prop: "teacherName"
                },
                {
                    label: "所在部门",
                    checked: true,
                    disabled: true,
                    prop: "tchOrgName"
                },
                {
                    label: "实际平均分",
                    checked: true,
                    disabled: true,
                    prop: "averageScore"
                },
                {
                    label: "有效平均分",
                    checked: true,
                    disabled: true,
                    prop: "actualAverageScore"
                },
                {
                    label: "排名",
                    checked: true,
                    prop: "orderNum"
                }
            ],
            // 督导 --教师得分对比
            DB_SUPERVISO_TEACHER: [
                {
                    label: "教师所在部门",
                    disabled: true,
                    checked: true,
                    prop: "orgName"
                },
                {
                    label: "教师",
                    disabled: true,
                    checked: true,
                    prop: "teacherName"
                },
                {
                    label: "教工号",
                    checked: true,
                    disabled: true,
                    prop: "teacherCode"
                },
                {
                    label: "性别",
                    checked: false,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    checked: false,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类型",
                    checked: false,
                    prop: "teacherType"
                },
                {
                    label: "平均分",
                    checked: true,
                    disabled: true,
                    prop: "averageScore"
                },
                {
                    label: "排名",
                    checked: true,
                    prop: "orderNum"
                }
            ],
            JD_SUPERVISO: [
                {
                    label: "督导姓名",
                    disabled: true,
                    checked: true,
                    prop: "userName"
                },
                {
                    label: "所在部门",
                    disabled: true,
                    srot: true,
                    checked: true,
                    prop: "orgName"
                },
                {
                    label: "督导角色",
                    checked: true,
                    prop: "roleType"
                },
                {
                    label: "任务项",
                    checked: true,
                    prop: "taskName"
                },
                {
                    label: "应评次数",
                    srot: true,
                    checked: true,
                    prop: "taskRequire"
                },
                {
                    label: "评价次数",
                    srot: true,
                    checked: true,
                    prop: "completeCount"
                },
                {
                    label: "状态",
                    checked: true,
                    prop: "completedStatus"
                }
            ],
            JD_LEADER: [
                {
                    label: "领导姓名",
                    checked: true,
                    disabled: true,
                    prop: "userName"
                },
                {
                    label: "所在部门",
                    checked: true,
                    srot: true,
                    prop: "orgName"
                },
                {
                    label: "领导角色",
                    checked: true,
                    prop: "roleType"
                },
                {
                    label: "任务项",
                    checked: true,
                    prop: "taskName"
                },
                {
                    label: "应评次数",
                    srot: true,
                    checked: true,
                    prop: "taskRequire"
                },
                {
                    label: "评价次数",
                    srot: true,
                    checked: true,
                    prop: "completeCount"
                },
                {
                    label: "状态",
                    checked: true,
                    prop: "completedStatus"
                }
            ],
            // 同行-听评课进度
            JD_COLLEAGUE: [
                {
                    label: "评价教师姓名",
                    disabled: true,
                    checked: true,
                    prop: "userName"
                },
                {
                    label: "所属部门",
                    checked: true,
                    srot: true,
                    disabled: true,
                    prop: "orgName"
                },
                {
                    label: "任务项",
                    checked: true,
                    disabled: true,
                    prop: "taskName"
                },
                {
                    label: "应评次数",
                    checked: true,
                    disabled: true,
                    srot: true,
                    prop: "taskRequire"
                },
                {
                    label: "评价次数",
                    checked: true,
                    disabled: true,
                    srot: true,
                    prop: "completeCount"
                },
                {
                    label: "状态",
                    checked: true,
                    prop: "completedStatus"
                }
            ],
            ZB_COLLEAGUE: [
                {
                    label: "教师所在部门",
                    disabled: true,
                    checked: true,
                    prop: "tchOrgCode"
                },
                {
                    label: "教工号",
                    checked: true,
                    disabled: true,
                    prop: "teacherCode"
                },
                {
                    label: "教师",
                    checked: true,
                    disabled: true,
                    prop: "teacherName"
                },
                {
                    label: "性别",
                    checked: true,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    checked: true,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类型",
                    checked: true,
                    prop: "teacherType"
                },
                {
                    label: "课程名称",
                    checked: true,
                    disabled: true,
                    prop: "courseName"
                },
                {
                    label: "上课时间",
                    checked: true,
                    prop: "classDate"
                },
                {
                    label: "上课地点",
                    checked: true,
                    prop: "place"
                },
                {
                    label: "评价指标",
                    checked: true,
                    prop: "kpiName"
                },
                {
                    label: "评价结果",
                    checked: true,
                    prop: "evaluateContent"
                },
                {
                    label: "得分",
                    checked: true,
                    prop: "score"
                },
                {
                    label: "评价人",
                    checked: true,
                    disabled: true,
                    prop: "evaluateUser"
                }
            ],
            // 督导、领导、同行--教师单个指标得分对比
            ZB_SUPERVISO: [
                {
                    label: "教师所在部门",
                    disabled: true,
                    checked: true,
                    prop: "tchOrgName"
                },
                {
                    label: "教工号",
                    checked: true,
                    disabled: true,
                    prop: "teacherCode"
                },
                {
                    label: "教师",
                    checked: true,
                    disabled: true,
                    prop: "teacherName"
                },
                {
                    label: "性别",
                    checked: true,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    checked: true,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类型",
                    checked: true,
                    prop: "teacherType"
                },
                {
                    label: "课程名称",
                    checked: true,
                    disabled: true,
                    prop: "courseName"
                },
                {
                    label: "上课时间",
                    checked: true,
                    prop: "classDate"
                },
                {
                    label: "上课地点",
                    checked: true,
                    prop: "place"
                },
                {
                    label: "评价指标",
                    checked: true,
                    prop: "kpiName"
                },
                {
                    label: "评价结果",
                    checked: true,
                    prop: "evaluateContent"
                },
                {
                    label: "得分",
                    checked: true,
                    prop: "score"
                },
                {
                    label: "评价人",
                    checked: true,
                    disabled: true,
                    prop: "evaluateUser"
                }
            ],
            ZB_STUDENT: [
                {
                    label: "教师所在部门",
                    disabled: true,
                    checked: true,
                    prop: "tchOrgName"
                },
                {
                    label: "教工号",
                    disabled: true,
                    checked: true,
                    prop: "teacherCode"
                },
                {
                    label: "教师",
                    disabled: true,
                    checked: true,
                    prop: "teacherName"
                },
                {
                    label: "性别",
                    checked: true,
                    prop: "teacherSex"
                },
                {
                    label: "职称",
                    checked: true,
                    prop: "teacherTitle"
                },
                {
                    label: "教师类型",
                    checked: true,
                    prop: "teacherType"
                },
                {
                    label: "课程名称",
                    disabled: true,
                    checked: true,
                    prop: "courseName"
                },
                {
                    label: "指标名称",
                    checked: true,
                    disabled: true,
                    prop: "kpiName"
                },
                {
                    label: "评价得分",
                    checked: true,
                    disabled: true,
                    prop: "averageScore"
                }
            ],
            // 领导听课进度
            JL_SUPERVISO: [
                {
                    label: "督导角色",
                    checked: true,
                    prop: "supervisorRole"
                },
                {
                    label: "督导所在部门",
                    checked: true,
                    disabled: true,
                    prop: "whereOrgIn"
                },
                {
                    label: "督导姓名",
                    checked: true,
                    disabled: true,
                    prop: "supervisorUser"
                },
                {
                    label: "被评课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "被评课程名称",
                    checked: true,
                    prop: "course"
                },
                {
                    label: "开课院系",
                    checked: true,
                    prop: "courseCollege"
                },
                {
                    label: "被评教师",
                    checked: true,
                    disabled: true,
                    prop: "teacherName"
                },
                {
                    label: "被评教师工号",
                    checked: true,
                    srot: true,
                    prop: "staffCode"
                },
                {
                    label: "被评教师所在部门",
                    checked: true,
                    prop: "teacherOrg"
                },
                {
                    label: "上课时间",
                    checked: true,
                    prop: "courseTime"
                },
                {
                    label: "上课地点",
                    checked: true,
                    prop: "place"
                },
                {
                    label: "评价得分",
                    checked: true,
                    prop: "score"
                },
                {
                    label: "提交时间",
                    checked: true,
                    srot: true,
                    prop: "evalDate"
                }
            ],
            JL_LEADER: [
                {
                    label: "领导角色",
                    checked: true,
                    prop: "leaderRoleCode"
                },
                {
                    label: "领导所在部门",
                    checked: true,
                    disabled: true,
                    prop: "whereOrgIn"
                },
                {
                    label: "领导姓名",
                    checked: true,
                    disabled: true,
                    prop: "leader"
                },
                {
                    label: "被评课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "被评课程名称",
                    checked: true,
                    prop: "course"
                },
                {
                    label: "开课院系",
                    checked: true,
                    prop: "courseCollege"
                },
                {
                    label: "被评教师",
                    checked: true,
                    disabled: true,
                    prop: "teacherName"
                },
                {
                    label: "被评教师工号",
                    checked: true,
                    srot: true,
                    prop: "staffCode"
                },
                {
                    label: "被评教师所在部门",
                    checked: true,
                    prop: "teacherOrg"
                },
                {
                    label: "上课时间",
                    checked: true,
                    prop: "courseTime"
                },
                {
                    label: "上课地点",
                    checked: true,
                    prop: "place"
                },
                {
                    label: "评价得分",
                    checked: true,
                    prop: "score"
                },
                {
                    label: "提交时间",
                    checked: true,
                    srot: true,
                    prop: "evalDate"
                }
            ],
            JL_COLLEAGUE: [
                {
                    label: "评价教师所在部门",
                    disabled: true,
                    checked: true,
                    prop: "org"
                },
                {
                    label: "评价教师",
                    checked: true,
                    disabled: true,
                    prop: "evaluateUser"
                },
                {
                    label: "被评课程类型",
                    checked: true,
                    prop: "courseType"
                },
                {
                    label: "被评课程名称",
                    checked: true,
                    prop: "course"
                },
                {
                    label: "开课院系",
                    checked: true,
                    prop: "courseCollege"
                },
                {
                    label: "被评教师",
                    checked: true,
                    disabled: true,
                    prop: "teacherName"
                },
                {
                    label: "被评教师工号",
                    checked: true,
                    srot: true,
                    prop: "staffCode"
                },
                {
                    label: "被评教师所在部门",
                    checked: true,
                    prop: "teacherOrg"
                },
                {
                    label: "上课时间",
                    checked: true,
                    prop: "courseTime"
                },
                {
                    label: "上课地点",
                    checked: true,
                    prop: "place"
                },
                {
                    label: "评价得分",
                    checked: true,
                    prop: "score"
                },
                {
                    label: "提交时间",
                    checked: true,
                    srot: true,
                    prop: "evalDate"
                }
            ]
            // 学生参评率
            // 教学班
            // CPL_JOIN_LEARN: [
            //   { label: '院系', disabled: true, prop: 'courseOrgName' },
            //   { label: '课程名称', disabled: true, prop: 'courseName' },
            //   { label: '选课课号', disabled: true, prop: 'thirdSystemCode' },
            //   { label: '教学班级名称', disabled: true, prop: 'teachingClassName' },
            //   { label: '应参评学生', disabled: true, prop: 'needEvalStuCount' },
            //   { label: '已参评学生', disabled: true, prop: 'stuEvaluatedCount' },
            //   { label: '完全未评学生', disabled: true, prop: 'notEvaluatedCount' },
            //   { label: '参评率', disabled: true, prop: 'evalPercent' }
            // ]
        };
    }
};



// WEBPACK FOOTER //
// ./src/api/text.js